import { useBoolean } from "react-use";
import type { CommunityMember, Space } from "@circle-react/types";
import { SpaceCardButtonsCurrentUser } from "./SpaceCardButtonsCurrentUser";
import { SpaceCardButtonsLoggedOutUser } from "./SpaceCardButtonsLoggedOutUser";

export interface SpaceCardButtonsProps {
  currentUser?: CommunityMember;
  isAdmin: boolean;
  isPrivate: boolean;
  isSpaceMember: boolean;
  isViewOnlyMasquerading: boolean;
  joinSpace: () => void;
  lockedButtonLabel: string;
  lockedButtonURL: string;
  space: Space;
  spaceAccessViaPaywall: boolean;
}

export const SpaceCardButtons = ({
  currentUser,
  isSpaceMember,
  isPrivate,
  isAdmin,
  lockedButtonLabel,
  lockedButtonURL,
  joinSpace,
  spaceAccessViaPaywall,
  space,
  isViewOnlyMasquerading,
}: SpaceCardButtonsProps) => {
  const [shouldShowDeletePopup, toggleDeletePopup] = useBoolean(false);

  if (currentUser) {
    return (
      <SpaceCardButtonsCurrentUser
        space={space}
        isSpaceMember={isSpaceMember}
        spaceAccessViaPaywall={spaceAccessViaPaywall}
        shouldShowDeletePopup={shouldShowDeletePopup}
        toggleDeletePopup={toggleDeletePopup}
        joinSpace={joinSpace}
        isViewOnlyMasquerading={isViewOnlyMasquerading}
        isPrivate={isPrivate}
        isAdmin={isAdmin}
      />
    );
  }

  return (
    <SpaceCardButtonsLoggedOutUser
      isPrivate={isPrivate}
      lockedButtonLabel={lockedButtonLabel}
      lockedButtonURL={lockedButtonURL}
      joinSpace={joinSpace}
    />
  );
};
